import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import i18n from 'micro-i18n';

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/cards/DeckProgress.scss';

const DeckProgress = ({
  progressTypeText,
  progressNum = 0,
  totalNum = 0,
  showDots = true
}) => {

  const hasProgress = !((isNaN(progressNum) || progressNum === 0) && (isNaN(totalNum) || totalNum === 0));

  const progressCompleted = hasProgress ? progressNum - 1 || 0 : 0;

  const progressDots = [];

  if (showDots && hasProgress) {
    for (let i = 0; i < totalNum; i++) {
      const isActive = i === (progressCompleted);
      const className = classNames('csw-progress-dot', { 'csw-active': isActive });
      progressDots.push(<div className={className} key={i} />);
    }
  }

  return (
    <div className="csw-deck-progress">

      {hasProgress
       ? <div className="csw-deck-has-progress">

          {progressTypeText && <div
            className="csw-deck-progress-prefix">
            {showDots && <span>{JSON.stringify(totalNum)}{' '}</span>}
            <span>{progressTypeText}</span>
          </div>}

          {showDots
            ? <div className="csw-deck-progress-dots">
              {progressDots}
            </div>
            : <div className="csw-deck-progress-counter">
              {i18n.t('PROGRESS_OF_TOTAL', {
                progress: progressNum,
                total: totalNum
              })}
            </div>}

       </div>
       : <div className="csw-deck-no-progress">{' '}</div>}

    </div>
  );
};

DeckProgress.propTypes /* remove-proptypes */ = {
  progressTypeText: PropTypes.string,
  progressNum: PropTypes.number,
  showDots: PropTypes.bool,
  totalNum: PropTypes.number
};

export default DeckProgress;
